<template>
  <div class="update-popup-con">
    <div class="table-con">
      <div class="table-header">
        <h3>UPDATE ORDER ALLOCATIONS</h3>
      </div>

      <div v-if="isAdmin">
      <div class="sk-switch-con">
        <CSwitch v-model="inputVisible" color="#4caf50">Is a PO required?</CSwitch>
      </div>
      <div class="sk-input-con" v-if="inputVisible">
        <label for="input">PO #</label>
        <input id="input" type="text" v-model="inputData" class="input">
      </div>

      <div class="select-con">
        <h3>Select Ship-TO for Order:</h3>
        <model-select :options="options"
                      v-model="selectValue"
                      placeholder="Please select allocation address">
        </model-select>
      </div>
      </div>

      <vue-good-table
          :columns="columns"
          :rows="rows"
          :sort-options="{
           enabled: false
        }"
      >
        <template slot="table-row" slot-scope="props">
    <span v-if="props.column.field === 'qty'">
<!--      {{JSON.stringify(props.row)}}-->
      <input type="number" class="input-number" step="1" min="0" :max="props.row.available"
             :value="qty[''+props.row.id]"
             @change="(e)=>someHandler(props.row.id,e.target.value)">
    </span>
          <span v-else>
      {{ props.formattedRow[props.column.field] }}
    </span>
        </template>
      </vue-good-table>
          <div class="button-con">
            <CButton color="green" text="Save" @click="onSaveClick"/>
            <div class="ml20">
              <CButton color="red" text="Cancel" @click="onCancel"/>
            </div>
          </div>
    </div>

  </div>
</template>

<script>
import CButton from "../common/CButton.vue";
import { VueGoodTable } from 'vue-good-table';
import CSwitch from "../common/CSwitch.vue";
import { ModelSelect } from 'vue-search-select';

export default {
  name: 'UpdateLocalItemPopup',
  components: {
    CButton,
    VueGoodTable,
    ModelSelect,
    CSwitch
  },
  props: {
    addresses: Array,
    items: Array,
    currentAllocatedData: Object,
    onSave: Function,
    onCancel: Function,
    isAdmin:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns: [
        {
          label: 'Product Name',
          field: 'name',
          type: 'string',
          width: '80%'
        },
        {
          label: 'Qty',
          field: 'qty',
          type: 'number',
          width: '20%'
        },
      ],
      qty: {},
      inputVisible: false,
      inputData: '',
      selectValue: {
        value: '',
        text: ''
      },
    }
  },
  computed: {
    rows(){
      return this.items.map((item)=>{
        return {
          id: item.id,
          name: item.title,
          qty: 0
        }
      });
    },
    options(){
      return this.addresses.map((item,index)=>{
        return {
          value: index,
          text: item.title
        }
      });
    },
  },
  mounted() {

    // this.selectValue ={
    //   value: this.getAddressIndexById(this.data.address_id),
    //   text: this.data.address
    // }



    const allocation_qty = this.currentAllocatedData.allocation_qty;
    for(let i=0;i<this.items.length;i++){
      this.qty[''+this.items[i].id] = allocation_qty[''+this.items[i].id];
    }



    if(this.isAdmin){

      this.selectValue ={
        value: this.getAddressIndexById(this.currentAllocatedData.address_id),
        text: this.currentAllocatedData.address
      }

      this.inputVisible = !!this.currentAllocatedData.po_required;
      this.inputData = this.currentAllocatedData.po_number||'';
      this.inputPoDate = this.currentAllocatedData.poDate||'';
    }
  },
  methods: {
    onSaveClick(){
      if(!this.isAdmin){
        this.onSave(this.qty);
      }else{
        const index = Number(this.selectValue.value);
        let data = {
          allocation_qty: this.qty,
          po_required: this.inputVisible,
          address_id: this.addresses[index].id,
          address_name:  this.addresses[index].title
        }
        if (this.inputVisible) {
          data.po_number = this.inputData;
          data.poDate = this.inputPoDate;
        }

        this.onSave(data);
      }

    },
    someHandler(id,value){
      this.qty[''+id] = value;
    },
    getAddressIndexById(id){
      return this.addresses.findIndex((item)=>{
        return item.id===id
      })
    }
  }
}
</script>